package com.fireavert.reports_page.reports_page.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class ReportsEventsRequest(val type: String, val propertyId: Int?, val token: String, val timeZone: String)
